<template>
    <j-modal
      :title="title"
      width="40%"
      :visible="visible"
      switchFullscreen
      @ok="handleOk"
      :body-style="{ height: '380px', overflow: 'hidden', overflowY: 'scroll' }"
      :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
      @cancel="handleCancel"
      :cancelText="$t('关闭')"
    >
      <a-spin :spinning="confirmLoading">
        <j-form-container :disabled="disableSubmit">
          <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('表编号')" prop="meterId">
                  <a-input v-model="model.meterId" :placeholder="$t('请输入表编号')" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('出厂日期')" prop="productionTime">
                  <a-date-picker
                    v-model="model.productionTime"
                    value-format="YYYY-MM-DD"
                    :placeholder="$t('出厂日期')"
                    style="width: 100%"
                    disabled
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('检定结果')" prop="inspectionState">
                  <j-dict-select-tag v-model="model.inspectionState" :showSearch="false" :placeholder="$t('请选择检定结果')" dictCode="verification_results" @input="inspectionStateChange" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('检定日期')" prop="inspectionTime">
                  <a-date-picker v-model="model.inspectionTime" value-format="YYYY-MM-DD" :placeholder="$t('请选择检定日期')" style="width: 100%" :disabled-date="disabledDate1" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12" v-if="model.inspectionState==1">
                <a-form-model-item :label="$t('到检日期')" prop="nextInspectionTime">
                  <a-date-picker v-model="model.nextInspectionTime" value-format="YYYY-MM-DD" :placeholder="$t('到检日期')" style="width: 100%" :disabled-date="disabledDate2" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('操作员')" prop="inspectionBy">
                    <j-select-user-by-dep v-model="model.inspectionBy" :multi="false"></j-select-user-by-dep>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </j-form-container>
      </a-spin>
    </j-modal>
  </template>
        
        <script>
import { postAction } from '../../../api/manage'
  import JDictSelectTag from '../../../components/dict/JDictSelectTag.vue'
  import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
  import moment from 'moment'
  import Vue from 'vue'
import { USER_NAME } from "@/store/mutation-types";
  export default {
    name: 'MeterCycleModalWheelInspection',
    components: { JDictSelectTag,JSelectUserByDep },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        url: {
            add: "/jeecg-charge/meterInspectionRecord/add",
            edit: "/jeecg-charge/meterInspectionRecord/edit",
        },
      }
    },
    computed: {
      validatorRules() {
        return {
            inspectionState: [{ required: true, message: this.$t('请选择检定结果'), trigger: 'change' }],
            inspectionTime: [{ required: true, message: this.$t('请选择检定日期'), trigger: 'change' }],
            nextInspectionTime: [{ required: true, message: this.$t('请选择到检日期'), trigger: 'change' }],
            inspectionBy: [{ required: true, message: this.$t('请选择操作员'), trigger: 'change' }],
        }
      },
    },
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        this.model = Object.assign({}, record)
        this.visible = true
        if(!record.inspectionBy){
          this.$set(this.model, 'inspectionBy', Vue.ls.get(USER_NAME))
        }
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        this.$refs.form
          .validate(valid => {
            if (valid) {
              this.confirmLoading = true
              let url = this.model.id ? this.url.edit : this.url.add;
              let message = this.model.id ? this.$t('编辑成功') : this.$t('新增成功');
              postAction(url,this.model).then(res=>{
                if(res.success){
                  this.$message.success(message);
                  this.visible = false;
                  this.$emit('ok');
                }else{
                  this.$message.warning(res.message);
                }
              }).finally(()=>{
                this.confirmLoading = false
              })
            }
          })
          .catch(() => {
            this.confirmLoading = false
          })
      },
      submitCallback() {
        this.$emit('ok')
        this.visible = false
      },
      handleCancel() {
        this.close()
      },
      inspectionStateChange(e){
        if(e == 2){
          this.$set(this.model, 'nextInspectionTime', '');
        }
      },
      disabledDate1(current) {
        // 只能选择今天及今天之前
        return current && current > moment().endOf('day')
      },
      disabledDate2(current) {
        // 只能选择今天及今天之后
        return current && current < moment().startOf('day')
      },
    },
  }
  </script>
      <style scoped>
  .table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
    border-right: 1px solid #e8e8e8;
  }
  
  .table-fixed /deep/ .resize-table-th {
    position: relative;
  }
  .table-fixed /deep/ .table-draggable-handle {
    border: 1px solid red;
    height: 100% !important;
    left: auto !important;
    right: -5px;
    cursor: col-resize;
    touch-action: none;
    border: none;
    position: absolute;
    transform: none !important;
    bottom: 0;
  }
  </style>